import { Action } from 'redux';

import { RuntimeActions, RuntimeMsg } from '../runtime.register';

const SCROLL_TOP = RuntimeMsg(RuntimeActions.ScrollTop, { selector: 'body', duration: 300 });
export function scrollTop(): Action {
    return SCROLL_TOP;
}

export function scrollToSelector(selector: string): Action {
    return RuntimeMsg(RuntimeActions.ScrollTop, { selector, duration: 300 });
}
